export function enableSwitcher() {
  const langSwitch = document.getElementById('language-nav');
  if (langSwitch) {
    langSwitch.onchange = function () {
      location.href = (<HTMLInputElement>langSwitch).value;
    };
  }
}
